import { FoodHalalIcon } from './FoodHalalIcon';

/**
 * author: Haley Halcyon
 * id F576B145-F06D-49FA-9616-2423C5D322AD
 * name food-halal
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-halal.svg
 * tags
 * - Food / Drink 
 */
export const DietaryRestrictionIcon = FoodHalalIcon;
export default DietaryRestrictionIcon